module.exports = __webpack_public_path__ + "static/media/vehicle-big.077a83aa.svg";